import { connect } from "react-redux";
import { DialysisSingleSelect as Component } from "./DialysisSingleSelect";

function mapStateToProps(state) {
  return {
    concentration: state.dialysisConcentration.concentration,
  };
}

export const DialysisSingleSelect = connect(mapStateToProps, {})(Component);
